import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/fund_value_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  fund_id_eq: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'FundValue',
  },
  fund: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'FundValue',
  },
  date_gteq: {
    column_type: 'date',
    model_name: 'FundValue',
    column_name: 'date',
  },
  date_lteq: {
    column_type: 'date',
    model_name: 'FundValue',
    column_name: 'date',
  },
}
export const formColumnsConfig = {
  'self': {
    'value': { required: true, disabledUpdate: false },
    'accumulative_value': { required: true, disabledUpdate: false },
    'date': { required: true, disabledUpdate: false },
    'fund_id': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('FundValue', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('FundValue', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
